import _ from "lodash";
import moment from "moment";

const DATE = "date";

const filtersWhiteList = {
  admin_id: true,
  approved_after: DATE,
  approved_before: DATE,
  budget_rate_type_id: true,
  company_size: true,
  end_after: DATE,
  end_before: DATE,
  filled_references: true,
  full_time_job: true,
  industry: true,
  last_activity_after: DATE,
  last_activity_before: DATE,
  last_login_after: DATE,
  last_login_before: DATE,
  level: true,
  metro_area: true,
  must_skill_category: true,
  must_skill: true,
  nice_skill_category: true,
  nice_skill: true,
  referral_type: true,
  role_id: true,
  signed_up_after: DATE,
  signed_up_before: DATE,
  skill_category: true,
  skill: true,
  start_after: DATE,
  start_before: DATE,
  status_id: true,
  submitted_after: DATE,
  submitted_before: DATE,
  potential: true
};

const objectToQueryParams = filtersObject => {
  let queryParams = "";

  _.forEach(filtersObject, function(valuesArray, filterKey) {
    // format of filters -> filter[role_id]=id1,id2,id3
    queryParams += `&filter[${filterKey}]=${valuesArray.join(",")}`;
  });

  return queryParams;
};

export default filters => {
  const filtersObject = {}; // an object of arrays

  if (filters) {
    filters.forEach(fieldsObject => {
      _.forEach(fieldsObject, function(filterValue, filterKey) {
        // if filterKey appears in the whitelist
        if (filtersWhiteList[filterKey]) {
          // if it's DATE then formatting it
          const finalValue =
            filtersWhiteList[filterKey] === DATE && filterValue
              ? moment(filterValue).format("YYYY-MM-DD")
              : filterValue;

          // since filtersObject[filterKey] is an array of possibles values (if one filter was selected more than once)
          if (filtersObject[filterKey]) {
            filtersObject[filterKey].push(finalValue);
          } else {
            filtersObject[filterKey] = [finalValue];
          }
        }
      });
    });
  }

  return objectToQueryParams(filtersObject);
};



// WEBPACK FOOTER //
// ./src/utils/parseFilters.js